import { createWebHistory, createRouter } from "vue-router";
import routes from "./routes";
import SecureLS from "secure-ls";

const ls = new SecureLS();

const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  const publicPages = [
    "/login",
    "/register",
    "/forgot-password",
    "/reset-password",
  ];

  const authRequired = !publicPages.includes(routeTo.path);
  const token = ls.get("token");
  const user = ls.get("user");

  console.log(
    "Route:",
    routeTo.path,
    "Auth Required:",
    authRequired,
    "Has Token:",
    !!token
  );

  if (authRequired && (!token || !user)) {
    // Clear any invalid auth data
    ls.remove("token");
    ls.remove("user");
    ls.remove("permissions");

    return next({
      path: "/login",
      query: { redirectFrom: routeTo.fullPath },
    });
  }

  // If going to login page but already authenticated, redirect to dashboard
  if (routeTo.path === "/login" && token && user) {
    return next("/");
  }

  next();
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
